
    import {Options, Vue} from "vue-class-component"
    @Options({
        props: {
            spinnerSize: String,
        }
    })

    export default class spinner extends Vue {
        
    }
